import { Moment } from "moment";
import { BookingWithData } from "PFCore/hooks/queries/profile";

export const splitBooking = (
  booking: BookingWithData,
  splitDates: string[],
  utc: (date: string) => Moment,
  formatISODate: (date: string) => string
): BookingWithData[] => {
  if (splitDates.length === 0) {
    return [booking];
  }

  const items: BookingWithData[] = [];
  let currentBooking = booking;

  const sortedSplitDates = splitDates.sort(
    (dateA, dateB) => new Date(dateA).getTime() - new Date(dateB).getTime()
  );

  sortedSplitDates.forEach((splitDate) => {
    const newBooking = {
      ...currentBooking,
      end_date: splitDate
    };
    items.push(newBooking);
    currentBooking = {
      ...currentBooking,
      start_date: formatISODate(utc(splitDate).add(1, "day").toISOString())
    };
  });
  items.push(currentBooking);

  return items;
};
